export const QUEUE_MONITORING = 'Queue Monitoring';
export const CALL_CENTER_MONITORING = 'Call Center Monitoring';
